import { useCurrentUser } from "@zapier/upsells/esm/hooks";
export const useCurrentAccountId = ({ skip, useQuery, } = {}) => {
    const { currentUser, error, isLoading } = useCurrentUser({
        skip,
        useQuery,
    });
    return {
        accountId: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.currentAccountId)
            ? parseInt(currentUser.currentAccountId)
            : undefined,
        error: error ? "Error loading current account ID." : undefined,
        isLoading,
    };
};

// @zapier/upsells@8.0.3 (1de7a616e)
